/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { SecurityHelper, Divider, FlexRow, FlexCol } from 'sarsaparilla';
import * as types from '../../constants';
import { AVAILABILITY_FILTERS } from '../../utils/utilsNew';
import NumericalAvailabilityFilter from '../../../shared-components/common/NumericalAvailabilityFilter';

export default class VenueFilter extends React.Component {
    static propTypes = {
        onFilterChange: PropTypes.func,
        quotaFilters: PropTypes.shape([]),
        permit: PropTypes.shape({
            name: PropTypes.string,
        }),
        hasMultipleOpenDivisions: PropTypes.bool,
    };

    static defaultProps = {
        permit: {},
        quotaFilters: {},
        onFilterChange: () => {},
    };
    constructor(props) {
        super(props);
        this.updateQuotaFilter = this.updateQuotaFilter.bind(this);
        this.renderFilters = this.renderFilters.bind(this);
    }

    updateQuotaFilter(quotaType, newValues) {
        const filterValues = { ...this.props.quotaFilters };
        filterValues[quotaType] = newValues.value;
        this.props.onFilterChange(filterValues);
    }

    renderFilters() {
        const renderedFilters = [];
        Object.keys(this.props.quotaFilters).forEach((quotaFilterType) => {
            const quotaFilter = AVAILABILITY_FILTERS(
                this.props.permit,
                this.props.permit.rules,
                SecurityHelper.isCommercialAccount()
            ).filter((filter) => filter.type === quotaFilterType)[0];
            if (!quotaFilter) {
                return;
            }

            if (
                quotaFilter.display === types.FILTER_NUMERICAL &&
                !quotaFilter.doNotRender
            ) {
                renderedFilters.push(
                    <NumericalAvailabilityFilter
                        className="center-content"
                        label={quotaFilter.labelAlt}
                        value={this.props.quotaFilters[quotaFilter.type]}
                        minValue={0}
                        maxValue={quotaFilter.maxValue}
                        onChange={(newValues) =>
                            this.updateQuotaFilter(quotaFilter.type, newValues)
                        }
                        key={quotaFilter.type}
                        renderVisibility={false}
                        fullWidth
                    />
                );
            }
        });

        return (
            <FlexRow>
                <FlexCol>{renderedFilters}</FlexCol>
                <FlexCol xs={12}>
                    <Divider />
                </FlexCol>
            </FlexRow>
        );
    }

    render() {
        if (!this.props.permit.name) {
            return null;
        }

        return this.renderFilters();
    }
}
